const StateSelectors = {
    USER_SELECTOR: state => state.user,
    REPORTS_SELECTOR: state => state.reports,
    UPLOAD_SELECTOR: state => state.upload,
    LOADER_SELECTOR: state => state.loader
}

export default StateSelectors